module.exports = __webpack_public_path__ + "img/2025big17.8ec73002.jpg";